import { TodoContext } from "./TodoContext";
import React from "react";
function CreateTodoBtn(){
    const {openModal, setOpenModal} = React.useContext(TodoContext);
    
    const abrirModal = () => {
        setOpenModal(!openModal);
    }

    return(
        <button className="taskApp__addTask" onClick={
            abrirModal
        }>
        </button>
    );
}

export { CreateTodoBtn };